import { Component, OnInit } from '@angular/core';
import { FormControl, FormGroup } from '@angular/forms';
import { Router } from '@angular/router';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap'
import { MonitorType } from 'src/app/core/models/monitor-type.model';
import { User } from 'src/app/core/models/user.model';
import { UserType } from 'src/app/core/models/userType.models';
import { BvTypeService } from 'src/app/core/services/bv-type.service';
import { HarnessTypeService } from 'src/app/core/services/harness-type.service';
import { MonitorTypeService } from 'src/app/core/services/monitor-type.service.';
import { UserService } from 'src/app/core/services/user.service';

@Component({
  selector: 'app-board',
  templateUrl: './harnessType.component.html',
  styleUrls: ['./harnessType.component.scss']
})

/**
 * Dashboard Component
 */
export class HarnessTypeComponent implements OnInit {
  term: any;
  harnessType: any[];

  addEditMode: any;
  harnessTypeFormGroup: FormGroup;


  constructor(
    private harnessTypeService: HarnessTypeService, 
    private modalService: NgbModal,
  ) { }

  // bread crumb items
  breadCrumbItems: Array<{}>;

  async ngOnInit(): Promise<void> {
    this.breadCrumbItems = [{ label: 'Fortune' }, { label: 'Harness Type', active: true }];
    await this.refresh();
  }

  async refresh() {
    
    this.harnessType = await this.harnessTypeService.getAll();
  

    console.log("refresh called", this)
  }

  async onAddNew(modal: unknown) {
    this.addEditMode = "Add";
    this.harnessTypeFormGroup = new FormGroup({
      id: new FormControl<string>(''),
      name: new FormControl<string>(''),


    });
    try {
      const results = await this.modalService.open(modal).result;
      console.log('add edit modal returned', {results, saleRepAddEditFormGroup: this.harnessTypeFormGroup.value});
      if(results=="Save click") {
        const newPrinterType = await this.harnessTypeService.create(this.harnessTypeFormGroup.value);
        if(newPrinterType != null) {
          //TODO mark sucesss
        } else {
          //TODO mark failure
        }
      } else {
        //TODO mark cancel
      }
    } catch (error) {
      //TODO mark error
    }
    await this.refresh();
  }

  async onEdit(modal: unknown, original: MonitorType) {
    this.addEditMode = "Edit";
    this.harnessTypeFormGroup = new FormGroup({
      id: new FormControl<string>(original.id),
      name: new FormControl<string>(original.name),
      

    });
    try {
      const results = await this.modalService.open(modal).result;
      console.log('add edit modal returned', {results, gameFormGroup: this.harnessTypeFormGroup.value});
      if(results=="Save click") {
        const newGame = await this.harnessTypeService.update(original.id, this.harnessTypeFormGroup
          .value);
        if(newGame != null) {
          //TODO mark sucesss
        } else {
          //TODO mark failure
        }
      } else {
        //TODO mark cancel
      }
    } catch (error) {
      //TODO mark error
    }
    await this.refresh();
    
  } 

  async onDelete( id: string) {
    await this.harnessTypeService.delete(id);
    await this.refresh();     
  } 
}
